import { render, staticRenderFns } from "./AccountSharedLayout.vue?vue&type=template&id=33c1081e&scoped=true&"
import script from "./AccountSharedLayout.vue?vue&type=script&lang=js&"
export * from "./AccountSharedLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccountSharedLayout.vue?vue&type=style&index=0&id=33c1081e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c1081e",
  null
  
)

/* custom blocks */
import block0 from "./AccountSharedLayout.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports